/**
 * garage-fit.js — Factory 47 unified-garage collection fit badges (WS2)
 *
 * Renders a per-card "Fits your <bike>" / "Doesn't fit your <bike>" badge on
 * collection/search product cards, driven by the EasySearch YMM garage vehicle.
 * Never hides products (badge-only). Garage read + fit evaluation come from the
 * shared window.F47Garage helper (garage-core.js) — no parallel vehicle state.
 *
 *  - Bucket A (data-fit-tags): show Fits / Doesn't fit.
 *  - Bucket B (data-fit-universal="true"): always Fits.
 *  - Bucket C (no data-fit-* attrs): never badged.
 *  - "Doesn't fit" only on a product tagged for OTHER bikes, never a merely-untagged one.
 *  - Any failure (no garage, no map, unknown vehicle) => no badges.
 *  - Feature-flagged OFF by default; loaded only when the badge flag is on.
 */
(function () {
  'use strict';

  var G = window.F47Garage;
  if (!G) return; // core missing => no-op (graceful)

  var BADGE_CLASS = 'f47-fit-badge';
  var CARD_SELECTOR = 'product-card[data-fit-tags], product-card[data-fit-universal]';

  function clearBadges(root) {
    var scope = root || document;
    var badges = scope.querySelectorAll('.' + BADGE_CLASS);
    for (var i = 0; i < badges.length; i++) badges[i].parentNode && badges[i].parentNode.removeChild(badges[i]);
  }

  function buildBadge(status, label) {
    var span = document.createElement('span');
    span.className = BADGE_CLASS + ' ' + BADGE_CLASS + '--' + status;
    span.setAttribute('role', 'status');
    var text = status === 'fit' ? 'Fits your ' + label : "Doesn't fit your " + label;
    span.setAttribute('aria-label', text);
    var icon = document.createElement('span');
    icon.className = BADGE_CLASS + '__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = status === 'fit' ? '✓' : '✕';
    var txt = document.createElement('span');
    txt.className = BADGE_CLASS + '__text';
    txt.textContent = status === 'fit' ? 'Fits your bike' : "Doesn't fit";
    span.appendChild(icon);
    span.appendChild(txt);
    return span;
  }

  function badgeCard(card, slugs, label) {
    clearBadges(card);
    var universal = card.getAttribute('data-fit-universal') === 'true';
    var status;
    if (universal) {
      status = 'fit';
    } else {
      var tags = (card.getAttribute('data-fit-tags') || '').split(/\s+/).filter(Boolean);
      if (!tags.length) return; // Bucket C safety net
      status = G.fits(slugs, tags, false) ? 'fit' : 'nofit';
    }
    var badge = buildBadge(status, label);
    var titleEl = card.querySelector('.card__title');
    if (titleEl) { titleEl.insertAdjacentElement('afterend', badge); }
    else { (card.querySelector('.card__info-inner') || card).appendChild(badge); }
  }

  function run() {
    var vehicle = G.readActiveVehicle();
    if (!vehicle) { clearBadges(); return; }
    G.loadFitmentMap().then(function (map) {
      var slugs = G.resolveSlugs(vehicle, map);
      if (!slugs) { clearBadges(); return; }
      var cards = document.querySelectorAll(CARD_SELECTOR);
      for (var i = 0; i < cards.length; i++) {
        (function (card) { G.safe(function () { badgeCard(card, slugs, vehicle.label); }); })(cards[i]);
      }
    });
  }

  var pending = null;
  function scheduleRun() { if (pending) clearTimeout(pending); pending = setTimeout(run, 120); }

  function init() {
    run();
    window.addEventListener('storage', function (e) { if (e.key === G.STORAGE_KEY) run(); });
    if (window.MutationObserver) {
      var obs = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          for (var j = 0; j < muts[i].addedNodes.length; j++) {
            var n = muts[i].addedNodes[j];
            if (n.nodeType === 1 && ((n.matches && n.matches(CARD_SELECTOR)) || (n.querySelector && n.querySelector(CARD_SELECTOR)))) { scheduleRun(); return; }
          }
        }
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
